export default __webpack_public_path__ + "static/favicon-6f81f80364e22023e6984b5d4bd1a8f7.ico";